import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import {
  PostAcceptedPools,
  PostAttachAutoTuneV2Config,
  PostAutoTuneV2Config,
  PostDeleteAcceptedPools,
  PostSiteOrgConfig,
} from "../../api/api";

type AttachAutoTuneConfigResult = {
  status: string;
  notification?: boolean;
  msg?: string;
};

type AttachAutoTuneConfig = {
  attach: boolean;
  config_name: string;
  config_type: string;
  sites: string[];
};

export const useAttachQSE = () => {
  const { getAccessTokenSilently } = useAuth0();

  const mutation = useMutation({
    mutationFn: ({
      config_name,
      config_type,
      attach,
      sites,
      token,
    }: AttachAutoTuneConfig & {
      token: string;
    }): Promise<AttachAutoTuneConfigResult> =>
      PostAttachAutoTuneV2Config(
        token,
        {
          config_name,
          config_type,
          attach,
        },
        sites
      ),

    onSuccess: (data) => {},

    onError: (error) => {
      console.error(
        "Error performing miner operations:",
        error
      );
    },
  });

  const mutateWithToken = useCallback(
    async (
      {
        config_name,
        config_type,
        attach,
        sites,
      }: AttachAutoTuneConfig,
      options?: {
        onSuccess?: (
          data: AttachAutoTuneConfigResult
        ) => void;
        onError?: (error: any) => void;
        onSettled?: () => void;
      }
    ) => {
      console.log("sites in attach price config", sites);
      const token = await getAccessTokenSilently();
      console.log();
      mutation.mutate(
        {
          config_name,
          config_type,
          attach,
          sites,
          token,
        },
        {
          onSuccess: options?.onSuccess,
          onError: options?.onError,
          onSettled: options?.onSettled,
        }
      );
    },
    [getAccessTokenSilently, mutation]
  );

  return { ...mutation, mutate: mutateWithToken };
};
